import * as types from "./types";

const fetchWalletStart = () => ({
   type: types.FETCH_WALLET_START,
});
const fetchWalletCompleted = (data) => ({
   type: types.FETCH_WALLET_COMPLETED,
   payload: data,
});
const fetchWalletFailed = () => ({
   type: types.FETCH_WALLET_FAILED,
});

const fetchWalletPaymentHistoryStart = () => ({
   type: types.FETCH_WALLET_PAYMENT_HISTORY_START,
});
const fetchWalletPaymentHistoryCompleted = (data) => ({
   type: types.FETCH_WALLET_PAYMENT_HISTORY_COMPLETED,
   payload: data,
});
const fetchWalletPaymentHistoryFailed = () => ({
   type: types.FETCH_WALLET_PAYMENT_HISTORY_FAILED,
});

const fetchNextWalletPaymentHistoryStart = () => ({
   type: types.FETCH_NEXT_WALLET_PAYMENT_HISTORY_START,
});
const fetchNextWalletPaymentHistoryCompleted = (data) => ({
   type: types.FETCH_NEXT_WALLET_PAYMENT_HISTORY_COMPLETED,
   payload: data,
});
const fetchNextWalletPaymentHistoryFailed = () => ({
   type: types.FETCH_NEXT_WALLET_PAYMENT_HISTORY_FAILED,
});

const checkWalletLimitStart = () => ({
   type: types.CHECK_WALLET_LIMIT_START,
});
const checkWalletLimitCompleted = (data) => ({
   type: types.CHECK_WALLET_LIMIT_COMPLETED,
   payload: data,
});
const checkWalletLimitFailed = (data) => ({
   type: types.CHECK_WALLET_LIMIT_FAILED,
   payload: data,
});

const setWalletLimitState = (data) => ({
   type: types.SET_WALLET_LIMIT_MODAL_STATE,
   payload: data,
});

const wallletPurchaseStart = () => ({
   type: types.WALLET_PURCHASE_START,
});
const wallletPurchaseCompleted = (data) => ({
   type: types.WALLET_PURCHASE_COMPLETED,
   payload: data,
});
const wallletPurchaseFailed = () => ({
   type: types.WALLET_PURCHASE_START_FAILED,
});
const setWallletPurchaseStatus = data => ({
   type: types.SET_WALLET_PURCHASE_STATUS,
   payload: data,
});
const setModalState = data => ({
   type: types.SET_MODAL_STATE,
   payload: data,
});

export {
   fetchWalletStart,
   fetchWalletCompleted,
   fetchWalletFailed,

   fetchWalletPaymentHistoryStart,
   fetchWalletPaymentHistoryCompleted,
   fetchWalletPaymentHistoryFailed,

   fetchNextWalletPaymentHistoryStart,
   fetchNextWalletPaymentHistoryCompleted,
   fetchNextWalletPaymentHistoryFailed,

   checkWalletLimitStart,
   checkWalletLimitCompleted,
   checkWalletLimitFailed,
   setWalletLimitState,

   wallletPurchaseStart,
   wallletPurchaseCompleted,
   wallletPurchaseFailed,

   setWallletPurchaseStatus,
   setModalState,
};
